"use strict";

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.function.name.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash"));

var _excluded = ["children", "fieldSpacing", "editable", "onModifySchema", "editableInterface"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OmitFields = ["fieldsFromRedux", "valuesFromRedux", "onModifySchema", "parent", "fieldSpacing", "isEditable", "onClickEditableInterface", "editing", "clear_editing_field"];

var CheckIsEditing = function CheckIsEditing(_ref) {
  var name = _ref.name,
      editing = _ref.editing;
  return _lodash["default"].isEqual(name, editing);
};

var FieldContainer = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(FieldContainer, _PureComponent);

  var _super = _createSuper(FieldContainer);

  function FieldContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FieldContainer);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyboardAction", function (e) {
      // esc = 27
      // checking to see if we're mouse over
      if (_this.state.isOver) {
        // check to see if we're editing, and if the key code is 27
        if (e.keyCode === 27 && _this.state.editing) {
          _this.setState({
            editing: false
          });

          _this.props.clear_editing_field(_this.props.name);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSave", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          _assertThisInitialize2 = _assertThisInitialize.state,
          editing = _assertThisInitialize2.editing,
          content = _assertThisInitialize2.content,
          _assertThisInitialize3 = _assertThisInitialize.props,
          name = _assertThisInitialize3.name,
          onModifySchema = _assertThisInitialize3.onModifySchema,
          clear_editing_field = _assertThisInitialize3.clear_editing_field;

      if (_lodash["default"].isFunction(onModifySchema) && editing) {
        _this.setState({
          editing: false
        }, function () {
          clear_editing_field(name);
          onModifySchema({
            name: name,
            value: content
          });
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCancel", function () {
      _this.setState({
        editing: false
      }, function () {
        return _this.props.clear_editing_field(_this.props.name);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editMenu", function () {
      var _assertThisInitialize4 = (0, _assertThisInitialized2["default"])(_this),
          editing = _assertThisInitialize4.state.editing;

      return editing && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: _this.onSave
      }, "Save Changes"), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: _this.onCancel
      }, "Cancel"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickField", function () {
      var _assertThisInitialize5 = (0, _assertThisInitialized2["default"])(_this),
          editing = _assertThisInitialize5.state.editing,
          label = _assertThisInitialize5.props.label;

      if (!editing) {
        _this.setState({
          editing: true,
          content: !editing ? label : undefined
        });
      }
    });

    var _editing = CheckIsEditing(_this.props);

    _this.state = {
      editing: _editing,
      content: _editing ? _this.props.label : undefined,
      isOver: false
    };
    return _this;
  }

  (0, _createClass2["default"])(FieldContainer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (CheckIsEditing(this.props) !== CheckIsEditing(nextProps)) {
        this.setState({
          editing: CheckIsEditing(nextProps),
          content: CheckIsEditing(nextProps) ? nextProps.label : undefined
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var editing = this.state.editing;

      if (editing) {
        this.setState({
          content: editing ? this.props.label : undefined
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("keyup", this.onKeyboardAction);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keyup", this.onKeyboardAction);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          editing = _this$state.editing,
          content = _this$state.content;
      var _this$props = this.props,
          children = _this$props.children,
          fieldSpacing = _this$props.fieldSpacing,
          editable = _this$props.editable,
          onModifySchema = _this$props.onModifySchema,
          editableInterface = _this$props.editableInterface,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);

      if (content && editing && _lodash["default"].has(editableInterface, props["interface"].toLowerCase()) && editableInterface[props["interface"]]) {
        props["interface"] = editableInterface[props["interface"]];
        props.value = content;

        props.onChange = function (content) {
          return _this2.setState({
            content: content
          });
        };

        props.label = "";
      } else {
        // TODO: Fix this hacky solution
        // setting props.value to be empty here always is hacky
        // but it's the only way to force the value to never be 'content'
        // since at this point editable fields will only be used on our
        // interface I think its ok.
        props.value = "";
      }

      var props_passed_to_children = _lodash["default"].omit(props, OmitFields);

      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.onClickField
      }, children(props_passed_to_children), this.editMenu());
    }
  }]);
  return FieldContainer;
}(_react.PureComponent);

FieldContainer.defaultProps = {
  editable: false,
  onClickEditableInterface: undefined,
  clear_editing_field: function clear_editing_field() {
    return false;
  }
};
FieldContainer.propTypes = {
  editableInterface: _propTypes.object.isRequired,
  editable: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool]).isRequired,
  onClickEditableInterface: _propTypes.func,
  clear_editing_field: _propTypes.func,
  children: _propTypes.func.isRequired
};
var _default = FieldContainer;
exports["default"] = _default;